var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { get, deletE, patch, post } from '../utils';
import hash from 'object-hash';
export var getCampaignList = function () { return __awaiter(void 0, void 0, void 0, function () {
    var payload;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                payload = {
                    params: {}
                };
                return [4 /*yield*/, get('/campaigns/all', payload)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var getOneCampaign = function (selectedCampaignID) { return __awaiter(void 0, void 0, void 0, function () {
    var payload, campaignID;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                payload = {
                    params: {}
                };
                campaignID = selectedCampaignID;
                return [4 /*yield*/, get("/campaigns/" + campaignID, payload)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var deleteCampaign = function (id, cascade) { return __awaiter(void 0, void 0, void 0, function () {
    var payload;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                payload = {
                    params: {}
                };
                if (!cascade) return [3 /*break*/, 2];
                return [4 /*yield*/, deletE("campaigns/" + id + "?cascade=true", payload)];
            case 1:
                _a.sent();
                return [3 /*break*/, 4];
            case 2: return [4 /*yield*/, deletE("campaigns/" + id, payload)];
            case 3:
                _a.sent();
                _a.label = 4;
            case 4: return [2 /*return*/, id];
        }
    });
}); };
export var updateCampaign = function (editedCampaignConfig, id, initialCampaignConfig) { return __awaiter(void 0, void 0, void 0, function () {
    var temp, payload, initialConfigHash, headers, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                temp = JSON.parse(JSON.stringify(initialCampaignConfig));
                delete temp['prjacc'];
                delete temp['tableData'];
                payload = editedCampaignConfig;
                initialConfigHash = hash(JSON.stringify(temp));
                headers = {
                    'initial-entity-hash': initialConfigHash
                };
                _a = {};
                return [4 /*yield*/, patch("campaigns/" + id, payload, { headers: headers })];
            case 1: return [4 /*yield*/, (_b.sent()).data];
            case 2: return [2 /*return*/, (_a.data = _b.sent(),
                    _a.id = id,
                    _a)];
        }
    });
}); };
export var addCampaign = function (campaign) { return __awaiter(void 0, void 0, void 0, function () {
    var payload;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                payload = campaign;
                return [4 /*yield*/, post("campaigns", payload)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var getGroupList = function () { return __awaiter(void 0, void 0, void 0, function () {
    var payload;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                payload = {
                    params: {}
                };
                return [4 /*yield*/, get('/campaign_groups/all', payload)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var addGroup = function (group) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, post("campaign_groups", group)];
            case 1: 
            // const payload = { campaign_groups: group };
            return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var updateGroup = function (group, id, initialGroup) { return __awaiter(void 0, void 0, void 0, function () {
    var temp, payload, initialConfigHash, headers, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                temp = JSON.parse(JSON.stringify(initialGroup));
                delete temp['prjacc'];
                payload = __assign(__assign({}, group), { id: id });
                initialConfigHash = hash(JSON.stringify(temp));
                headers = {
                    'initial-entity-hash': initialConfigHash
                };
                _a = {};
                return [4 /*yield*/, patch("campaign_groups/" + id, payload, { headers: headers })];
            case 1: return [4 /*yield*/, (_b.sent()).data];
            case 2: return [2 /*return*/, (_a.data = _b.sent(),
                    _a.id = id,
                    _a)];
        }
    });
}); };
//TODO
export var deleteGroup = function (id) { return __awaiter(void 0, void 0, void 0, function () {
    var payload;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                payload = {
                    params: {}
                };
                return [4 /*yield*/, deletE("campaign_groups/" + id, payload)];
            case 1:
                _a.sent();
                return [2 /*return*/, id];
        }
    });
}); };
export var getQueueList = function () { return __awaiter(void 0, void 0, void 0, function () {
    var payload;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                payload = {
                    params: {}
                };
                return [4 /*yield*/, get('/connect/queues?queueTypes=STANDARD', payload)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var getPhoneNumberList = function () { return __awaiter(void 0, void 0, void 0, function () {
    var payload;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                payload = {
                    params: {}
                };
                return [4 /*yield*/, get('/connect/phone-numbers', payload)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var getContactListList = function () { return __awaiter(void 0, void 0, void 0, function () {
    var payload;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                payload = {
                    params: {}
                };
                return [4 /*yield*/, get('/contactlists/all', payload)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var getDefaultCallerIDList = function () { return __awaiter(void 0, void 0, void 0, function () {
    var payload;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                payload = {
                    params: {}
                };
                return [4 /*yield*/, get('/twilio/outgoingcallerids', payload)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var getContactFlowList = function () { return __awaiter(void 0, void 0, void 0, function () {
    var payload;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                payload = {
                    params: {}
                };
                return [4 /*yield*/, get('/connect/contact-flows?flowTypes=CONTACT_FLOW', payload)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var getContactList = function (selectedContactListID) { return __awaiter(void 0, void 0, void 0, function () {
    var payload, contactListID;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                payload = {
                    params: {}
                };
                contactListID = selectedContactListID;
                return [4 /*yield*/, get("/contactlists/" + contactListID, payload)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
//# sourceMappingURL=Campaign.API.js.map